import { Component, OnInit, ViewChild, Directive, Input } from '@angular/core';
import { PolizasContratadasService } from "./polizas-contratadas.service";
import { ClienteLogin, ClienteXCiudad } from "../../login/cliente_login";
import { correctHeight, detectBody } from "../../../app.helpers";
import { SessionStorageService, } from "ngx-webstorage/dist/services";
import { SessionStorage } from "ngx-webstorage";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { Router } from '@angular/router';
import { SessionTokenService } from "../../../components/common/utils/sessionToken.service";
import { DatosGeneralesEntity } from "../entities/datos_generales_entity";
import { ModalComponent } from "ng2-bs3-modal/ng2-bs3-modal";
import { PolizaEntity } from "../entities/polizas_cliente_entity";
import { AplicacionesTransporteComponent } from "../aplicacionesTransporte/aplicaciones-transporte.component";
import { ExclusionVehiculos } from "../solicitudes/solicitud-vehiculos.component";
import { ExclusionVehiculosService } from "../solicitudes/solicitud-vehiculos.service";
import { ExclusionEquipos } from "../solicitudes/solicitud-equipo.component";
import { ExclusionEquiposService } from "../solicitudes/solicitud-equipo.service";
import { PolizasVencidasNoLiberadasService } from "../fianzas/polizasVencidasNoLiberadas/polizas-vencidasnoLiberadas.service";
import { PolizasVencidasNoLiberadasEntity } from "../fianzas/entities/polizas-vencidasnoLiberadas_entity";
import { UtilService } from '../../../components/common/utils/util.service';


const swal = require("sweetalert2");

declare var jQuery: any;
@Component({
    selector: 'polizasContratadas',
    providers: [],
    templateUrl: 'polizas-contratadas.template.html'

})

export class PolizasContratadas implements OnInit {
    usuario: ClienteLogin;
    polizas: PolizaEntity[];
    public showLoader: string;
    opcion: number;
    polizaContratada: PolizaEntity;
    show: boolean;
    showVeh: boolean;
    showEqu: boolean;
    showOtr: boolean;
    showRed: boolean;
    showPlanes: boolean;
    showListados: boolean;
    showSiniestralidad: boolean;
    showMovimientos: boolean;
    banderaFianza: boolean;
    banderaCredito: boolean;
    opciones: boolean;
    polizaDetalle: PolizasVencidasNoLiberadasEntity;
    detallePolizas1: PolizasVencidasNoLiberadasEntity[];
    @ViewChild('detallePolizas')
    modal: ModalComponent;
    poliza: string;
    rutaMovimientos: boolean;
    opcionSeleccionada: number = 0;
    rowSelect: number;
    showSolicitudes: boolean;
    @SessionStorage("cmbpolizas")
    public cmbpolizas;
    @SessionStorage("cmbpolizasData")
    public cmbpolizasdata;
    urlOrigen: string = "";
    urlAsesor: string = "";
    banderaCita: boolean = false;
    private userEmpresa: ClienteXCiudad;
    @ViewChild('agendarCita')
    modalAsesor: ModalComponent;
    segmento: number;

    constructor(
        private polizasContratadasService: PolizasContratadasService,
        public utilsService: UtilService,
        private exclusionVehiculosService: ExclusionVehiculosService,
        private router: Router,
        private sessionTokenService: SessionTokenService,
        private handleError: HandleError,
        public sesionStorageService: SessionStorageService,
        public polizasLiberadasService: PolizasVencidasNoLiberadasService) { }

    ngOnInit() {
        this.show = false;
        this.polizaDetalle = new PolizasVencidasNoLiberadasEntity();
        this.banderaFianza = false;
        this.banderaCredito = false;
        this.opciones = true;
        this.showVeh = false;
        this.showEqu = false;
        this.showOtr = false;
        this.showRed = false;
        this.showListados=false;
        this.showSolicitudes=false;
        this.showPlanes = false;
        this.showSiniestralidad = false;
        this.showMovimientos = false;
        this.showLoader = "sk-loading";
        this.polizas = new Array<PolizaEntity>();
        this.opcion = 0;
        this.polizaContratada = new PolizaEntity();
        this.detallePolizas1 = new Array<PolizasVencidasNoLiberadasEntity>();
        this.rutaMovimientos = false;
        this.segmento=0;
        /*correctHeight();
        detectBody();*/
        this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
        console.log("usu");
        console.log( this.usuario);
        if (this.usuario == null) {
            let error = { "status": 998, "message": "Acceso denegado" };
            this.handleError.redirectUrl(error)
        } else {
            let bandera = this.sessionTokenService.useJwtHelper();
            if (!bandera) {
                if (this.router.isActive('/patrimoniales/consultas/polizas', false) || this.router.isActive('/patrimoniales/solicitudes/movimientos', false)) {

                    if (this.router.isActive('/patrimoniales/solicitudes/movimientos', false)) {
                        this.rutaMovimientos = this.router.isActive('/patrimoniales/solicitudes/movimientos', false)
                    };

                    this.rutaParaConsultaPolizas(1, 1);
                    this.segmento=1;
                }
                if (this.router.isActive('/pymes/consultas/polizas', false) || this.router.isActive('/pymes/solicitudes/movimientos', false)) {

                    if (this.router.isActive('/pymes/solicitudes/movimientos', false)) {
                        this.rutaMovimientos = this.router.isActive('/pymes/solicitudes/movimientos', false)
                    };

                    this.rutaParaConsultaPolizas(4, 2)
                    this.segmento=4;
                }
                if (this.router.isActive('/fianzas/consultas/polizas', false)) {
                    this.banderaFianza = true;
                    this.opciones = false;
                    this.rutaParaConsultaPolizas(4, 3)
                    this.segmento=4;
                }
                if (this.router.isActive('/credito/consultas/polizas', false)) {
                    this.banderaCredito = true;
                    this.opciones = false;
                    this.rutaParaConsultaPolizas(4, 4)
                    this.segmento=4;
                }
                if (this.router.isActive('/VAM/consultas/polizas', false)) {
                    this.rutaParaConsultaPolizas(3, 5)
                    this.segmento=3;
                }

            }
        }
    }

    rutaParaConsultaPolizas(segmento: number, segmentoAlterno: number) {
        this.polizasContratadasService.consultaPolizasContratadas(segmento, segmentoAlterno)
            .subscribe(
            polizas => {
                this.polizas = polizas;
                this.showLoader = "";
                this.sesionStorageService.store('cmbpolizasData', JSON.stringify(polizas));

            },
            error => { this.handleError.redirectUrl(error); }
            );
            this.polizasContratadasService.consultaListaPolizas(segmento, segmentoAlterno)
            .subscribe(

                polizas => {
                    this.sesionStorageService.store('cmbpolizas', JSON.stringify(polizas));
                   // console.log(polizas);

                this.showLoader = "";
            },
            error => { this.handleError.redirectUrl(error); }
            );
    }


    consultarDetalle(poliza: PolizaEntity) {
        this.detallePolizas1 = new Array<PolizasVencidasNoLiberadasEntity>();
        this.polizaDetalle.AseCod = poliza.CodigoAseguradora;
        this.polizaDetalle.CiuCod = poliza.CodigoCiudad;
        this.polizaDetalle.CliCod = poliza.CodigoCliente;
        this.polizaDetalle.FinVigencia = poliza.FecVigFin;
        this.polizaDetalle.InicioVigencia = poliza.FecVigIni;
        this.polizaDetalle.NombreAseguradora = poliza.NombreAseguradora;
        this.polizaDetalle.NombreRamo = poliza.NombreRamo;
        this.polizaDetalle.PolCod = poliza.CodigoPoliza;
        this.polizaDetalle.RamCod = poliza.CodigoRamo;
        this.polizaDetalle.UniCod = poliza.CodigoUnidad;

        this.polizasLiberadasService.consultarListaDetallePolizasVencidas(this.polizaDetalle).subscribe(
            result => {
                this.detallePolizas1 = result;
                this.poliza = poliza.CodigoPoliza.trim();
                this.modal.open();
            },
            error => { this.handleError.redirectUrl(error); });
    }

    OpcionesChangePoliza(poliza: PolizaEntity, IdRow: number) {
        this.show = false;
        this.showVeh = false;
        this.showEqu = false;
        this.showOtr = false;
        this.showRed = false;
        this.showPlanes = false;
        this.showSiniestralidad = false;
        this.showMovimientos = false;
        this.showListados = false;
        this.showSolicitudes = false;
        this.showLoader = "sk-loading";
        this.rowSelect=IdRow;
        this.polizaContratada = new PolizaEntity();

        if (this.router.isActive('/patrimoniales/solicitudes/movimientos', false) || this.router.isActive('/pymes/solicitudes/movimientos', false)) {
            poliza.Accion = 4;
        }

        if (poliza.Accion == 1) {/*Listado*/
            this.polizasContratadasService.generarListado(poliza)
                .subscribe(result => {
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.className = "hidden"
                    let fileBlob = result.blob();
                    let blob = new Blob([fileBlob], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });
                    let url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = poliza.CodigoCliente + "-" + poliza.CodigoPoliza + "-" + poliza.CodigoRamo + ".xlsx";
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, poliza.CodigoCliente + "-" + poliza.CodigoPoliza + "-" + poliza.CodigoRamo + ".xlsx");
                    }
                    else {
                        a.click();
                        window.URL.revokeObjectURL(url);
                    }
                    this.showLoader = "";
                    poliza.Accion = 0;
                }, error => this.handleError.redirectUrl(error));
        }
        if (poliza.Accion == 3) {/*Aplicaciones*/
            this.show = true;
            this.polizaContratada = new PolizaEntity();
            this.polizaContratada = poliza;
            this.showLoader = "";
        }
        if (poliza.Accion == 4) {/*Movimientos*/

            this.polizaContratada = new PolizaEntity();
            this.polizaContratada = poliza;
            this.showLoader = "";

            switch (poliza.CodigoRamo) {
                case "1100": {
                    this.showVeh = true;
                    this.showEqu = false;
                    this.showOtr = false;
                    break;
                }
                case "0500":
                case "0700":
                case "2400": {
                    this.showVeh = false;
                    this.showEqu = true;
                    this.showOtr = false;
                    break;
                }
                default:
                    {
                        this.showVeh = false;
                        this.showEqu = false;
                        this.showOtr = true;
                        break;
                    }
            }

        }
        if (poliza.Accion == 0) {
            this.showLoader = "";
        }

        if (poliza.Accion == 5) {
            this.showRed = true;
            this.polizaContratada = new PolizaEntity();
            this.polizaContratada = poliza;
            this.showLoader = "";
        }

        if (poliza.Accion == 6) {
            this.showPlanes = true;
            this.polizaContratada = new PolizaEntity();
            this.polizaContratada = poliza;
            this.showLoader = "";
        }
        if (poliza.Accion == 7) {
            this.showSiniestralidad = true;
            this.polizaContratada = new PolizaEntity();
            this.polizaContratada = poliza;
            this.showLoader = "";
        }
        if (poliza.Accion == 8) {
            this.showMovimientos = true;
            this.polizaContratada = new PolizaEntity();
            this.polizaContratada = poliza;
            this.showLoader = "";
        }

        if (poliza.Accion == 9) {
            this.showListados = true;
            this.polizaContratada = new PolizaEntity();
            this.polizaContratada = poliza;
            this.showLoader = "";
        }
        if (poliza.Accion == 10) {
            this.showSolicitudes = true;
            this.polizaContratada = new PolizaEntity();
            this.polizaContratada = poliza;
            this.showLoader = "";
        }
        if (poliza.Accion == 11) {/*REsumen*/
            this.polizasContratadasService.generarResumen(poliza)
                .subscribe(result => {
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.className = "hidden"
                    let fileBlob = result.blob();
                    let blob = new Blob([fileBlob], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });
                    let url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = "Resumen" +poliza.CodigoCliente + "-" + poliza.CodigoPoliza + "-" + poliza.CodigoRamo + ".xlsx";
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, "Resumen" +poliza.CodigoCliente + "-" + poliza.CodigoPoliza + "-" + poliza.CodigoRamo + ".xlsx");
                    }
                    else {
                        a.click();
                        window.URL.revokeObjectURL(url);
                    }
                    this.showLoader = "";
                    poliza.Accion = 0;
                }, error => this.handleError.redirectUrl(error));
        }

        this.polizas.forEach(function (el) {
            if ((el.CodigoPoliza.trim() == poliza.CodigoPoliza.trim()) && (el.CodigoRamo != poliza.CodigoRamo))
                el.Accion = 0;

            if ((el.CodigoPoliza.trim() != poliza.CodigoPoliza.trim()) && (el.CodigoRamo != poliza.CodigoRamo))
                el.Accion = 0;

                if ((el.CodigoPoliza.trim() != poliza.CodigoPoliza.trim()) && (el.CodigoRamo == poliza.CodigoRamo))
                el.Accion = 0;
        });
    }
    CargarAsesor(bandera: number) {
      var bandTipoProceso = 7;
      let ban = 0;
      this.userEmpresa = this.sesionStorageService.retrieve("usuarioEmpresa");
      this.utilsService.getUriAsesorVirtual(bandera).subscribe(
        resultUri => {
          this.urlOrigen = resultUri;
          switch (bandera) {
            case 4: //polizas empresa /:cliCod/:ciuCod/:uniCod/:OrigenApp/:TipoPersona/:nombreUsuario/:TipoProceso/:Segmento",// corporativo
            let nombre="NA";
            this.urlAsesor = this.urlOrigen + this.userEmpresa.CodigoCliente + "/" + this.userEmpresa.Ciudad+"/0/1/2/"+nombre+"/"+bandTipoProceso+"/"+this.segmento;
            console.log(this.urlAsesor);
            break;
          }
          console.log("uri asesor", this.urlAsesor);
          this.banderaCita = true;
          this.modalAsesor.open();

          /*console.log("this.segmento");
          console.log(this.segmento);
          console.log("this.userEmpresa");
          console.log(this.userEmpresa);*/
        }
      );
    }

    CerrarModal() {
      this.banderaCita = false;
      this.urlAsesor = "";
    }
}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/polizasContratadas/polizas-contratadas.component.ts